import type { Lesson } from '@court-sync/shared';
import { getLessonDaysOfWeek as getLessonDaysOfWeekShared } from '@court-sync/shared';

type LessonWithLegacyDay = Lesson & { dayOfWeek?: number };

/**
 * Normalizes lesson schedule days across new and legacy lesson shapes.
 * Falls back to Sunday to match current schedule rendering behavior.
 */
export function getLessonDaysOfWeek(lesson: LessonWithLegacyDay): number[] {
  return getLessonDaysOfWeekShared(lesson);
}
